import React from 'react'
import styled from 'styled-components'
import BreadcrumbLink from './link'

import { Row } from '../Grid'
import { Text } from '../Text'

const Breadcrumbs = props => {
  const { links } = props
  return (
    <BreadcrumbsContainer>
      <Row
        as='ol'
        px={['17px', '10px']}
        pt={['0', '15px']}
        mb='5px'
        width={['100%', '1140px']}
        bg='white'
        flexWrap='wrap'
      >
        <BreadcrumbLink label='Home' href='/' alt='Buscar mais Psicólogos' position={1} />
        {links.length > 1 &&
          links.map((item, index) => {
            if (index < links.length - 1) {
              return (
                <Text as='span' variant='small' color='gray.n500' key={index}>
                  <Text as='span' variant='small' color='gray.n500' px='5px'>
                    {'>'}
                  </Text>
                  <BreadcrumbLink
                    key={Date.now()}
                    label={item.label}
                    href={item.link}
                    alt={item.alt}
                    position={links.indexOf(item) + 2}
                  />
                </Text>
              )
            }
          })}
        <Text as='span' variant='small' color='gray.n500' px='5px'>
          {'>'}
        </Text>
        <LinkStyled>{links[links.length - 1].label}</LinkStyled>
      </Row>
    </BreadcrumbsContainer>
  )
}

const BreadcrumbsContainer = styled(Row)`
  justify-content: center;
  background: #fff;
`
const LinkStyled = styled.a`
  font-size: 14px;
  color: #7f8c8d;
  &.active {
    color: #7f8c8d;
  }
  &:hover {
    color: #7f8c8d;
  }
`
export default Breadcrumbs
